import ActivityRenderer from "./ActivityRenderer";

export default ActivityRenderer;
